module.exports = __webpack_public_path__ + "static/woman-a-d2584aa724de5d4c3d041d30f73ca52a.jpg";